import { useEffect, useState } from 'react';
import { useAccount, useSignMessage } from 'wagmi';

/**
 * Keeper-tracked referrals. The diamond has no referral event, so an invite link (?ref=0x...) is linked off-chain:
 * the new player signs one free message (no transaction) and the round keeper records referrer -> referee.
 * Referral points stay PROPOSED, not an offer, and only count after the new player plays 10 rounds.
 */
const KEY = 'nt3d-ref';
const KEEPER = import.meta.env.VITE_KEEPER_URL || 'https://nt3d-round-keeper.wurkit.workers.dev';
export const referralMessage = (referrer: string, referee: string) =>
  `NT3D referral\nI was invited by ${referrer.toLowerCase()}\nPlayer ${referee.toLowerCase()}\nTestnet only. No transaction.`;

function captureRef() {
  try {
    const r = new URLSearchParams(window.location.search).get('ref');
    if (r && /^0x[0-9a-fA-F]{40}$/.test(r) && !localStorage.getItem(KEY)) localStorage.setItem(KEY, JSON.stringify({ referrer: r.toLowerCase(), done: false }));
  } catch { /* storage blocked */ }
}
captureRef();

export default function KeeperReferral() {
  const { address } = useAccount();
  const { signMessageAsync } = useSignMessage();
  const [state, setState] = useState<{ referrer: string; done: boolean } | null>(null);
  const [msg, setMsg] = useState('');
  useEffect(() => { try { setState(JSON.parse(localStorage.getItem(KEY) || 'null')); } catch { setState(null); } }, [address]);
  if (!address || !state || state.done || state.referrer === address.toLowerCase()) return null;
  const link = async () => {
    try {
      const signature = await signMessageAsync({ message: referralMessage(state.referrer, address) });
      const r = await fetch(`${KEEPER}/referral`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ referrer: state.referrer, referee: address, signature }) });
      const j = await r.json().catch(() => ({}));
      if (r.ok || j.error === 'already-linked') { const s = { ...state, done: true }; localStorage.setItem(KEY, JSON.stringify(s)); setState(s); }
      else setMsg(j.error || `error ${r.status}`);
    } catch (e: any) { setMsg(e?.shortMessage || 'cancelled'); }
  };
  const skip = () => { const s = { ...state, done: true }; localStorage.setItem(KEY, JSON.stringify(s)); setState(s); };
  return (
    <div role="status" style={{ margin: '8px auto', maxWidth: 720, padding: '8px 12px', border: '1px solid #843ee1', borderRadius: 8, fontSize: 13, background: 'rgba(20,10,40,.85)', color: '#ddd' }}>
      You were invited by {state.referrer.slice(0, 6)}...{state.referrer.slice(-4)}. Link the invite with one free signature (no transaction).{' '}
      <button type="button" onClick={link}>Sign</button> <button type="button" onClick={skip}>No thanks</button>
      {msg && <span style={{ color: '#f88' }}> {msg}</span>}
    </div>
  );
}
